var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 0.5H5.83333C2.61217 0.5 0 3.11217 0 6.33333V22.6667C0 25.8878 2.61217 28.5 5.83333 28.5H22.1667C25.389 28.5 28 25.8878 28 22.6667V6.33333C28 3.11217 25.389 0.5 22.1667 0.5ZM9.33333 22.6667H5.83333V9.83333H9.33333V22.6667ZM7.58333 8.354C6.45633 8.354 5.54167 7.43233 5.54167 6.296C5.54167 5.15967 6.45633 4.238 7.58333 4.238C8.71033 4.238 9.625 5.15967 9.625 6.296C9.625 7.43233 8.7115 8.354 7.58333 8.354ZM23.3333 22.6667H19.8333V16.1287C19.8333 12.1993 15.1667 12.4968 15.1667 16.1287V22.6667H11.6667V9.83333H15.1667V11.8925C16.7953 8.8755 23.3333 8.65267 23.3333 14.7812V22.6667Z",
    fill: "#0077B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1932d1da41c281030f7339b7283f916f.svg";
export { ForwardRef as ReactComponent };